import React, { useEffect, useRef, Fragment, useState } from 'react';
// @ts-ignore
import OpenSeadragon from 'openseadragon';
import { Box } from '@mui/material';
import queryString from 'query-string';

import { useGetImageForViewer } from '../api/useGetImageForViewer';

export function ImageViewer() {
    const viewerRef = useRef<HTMLDivElement>(null);
    const queryParams = queryString.parse(window.location.search);

    const {data, isLoading } = useGetImageForViewer(queryParams.fileToken);

    useEffect(() => {
        if (queryParams.source === 'file-indexing') {
            if (!queryParams.fileToken && typeof queryParams.fileToken !== 'string') {
                console.error('params invalido');
            }
        }
        else {
            console.error('source inválido');
        }
    }, []);

    useEffect(() => {
        if (viewerRef.current && data) {
            const objectUrl = URL.createObjectURL(data);

            const viewer = OpenSeadragon({
                element: viewerRef.current,
                prefixUrl: 'https://openseadragon.github.io/openseadragon/images/',
                tileSources: {
                    type: 'image',
                    url: objectUrl,
                },
                showNavigator: true,
                animationTime: 1.5,
                blendTime: 0.1,
                maxZoomPixelRatio: 2,
                minZoomLevel: 0.1,
                maxZoomLevel: 8,
                zoomPerScroll: 2,
                visibilityRatio: 1.0,
                constrainDuringPan: true,
                gestureSettingsMouse: {
                    scrollToZoom: true,
                    clickToZoom: false,
                    dblClickToZoom: true,
                    pinchToZoom: true,
                    flickEnabled: true,
                },
            });
        }
    }, [data]);

    return (
        <Box
            id="openseadragon-viewer"
            ref={viewerRef}
            style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}
        >
        </Box>
    );
}